import { BrowserRouter, Route } from 'react-router-dom';
import { Routes } from '@datadog/browser-rum-react/react-router-v6';
import { routes } from './index';
import PublicRoute from './PublicRoute';
import PrivateRoute from './PrivateRoute';
import ProtectedRoute from './ProtectedRoute';
import NotFound from '../component/page/validationPage/404';
import Index from './RouteIndex';

const AppRouter = () => (
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<Index />} />

      {routes.public.map(({ path, element }) => (
        <Route
          key={path}
          path={path}
          element={<PublicRoute>{element}</PublicRoute>}
        />
      ))}

      {/* Private Routes */}
      {routes.private.map(({ path, element }) => (
        <Route
          key={path}
          path={path}
          element={<PrivateRoute>{element}</PrivateRoute>}
        />
      ))}

      {/* Protected Routes */}
      {routes.protected.map(({ path, element, requiredRole }) => (
        <Route
          key={path}
          path={path}
          element={
            <ProtectedRoute requiredRole={requiredRole}>
              {element}
            </ProtectedRoute>
          }
        />
      ))}

      {/* 404 */}
      <Route path="*" element={<NotFound isRoot />} />
    </Routes>
  </BrowserRouter>
);

export default AppRouter;
